<script setup lang="ts">
	withDefaults(
		defineProps<{
			image?: string;
			alt?: string;
		}>(),
		{
			image: '',
			alt: '',
		},
	);
</script>

<template>
	<div
		class="flex flex-col md:flex-row md:items-center gap-10 rounded-xl border border-border-default bg-bg-box-default p-6 md:p-10 min-h-[540px]"
	>
		<div class="md:w-1/2 flex justify-center">
			<slot name="illustration">
				<img v-if="image" :src="image" class="max-w-full" :alt="alt" />
			</slot>
		</div>
		<div class="md:w-1/2 flex flex-col gap-6">
			<slot />
		</div>
	</div>
</template>
